import*as s from"./index.scss.js";const o=s;export{o as DropzoneTheme};
//# sourceMappingURL=index.js.map
